export default __webpack_public_path__ + "static/media/Icon10.056ae3b0.svg";